module.exports = __webpack_public_path__ + "static/img/A126.ddb72a6a.jpg";